import { render, staticRenderFns } from "./on-service-create-terminal.vue?vue&type=template&id=c1a412a6"
import script from "./on-service-create-terminal.vue?vue&type=script&lang=js"
export * from "./on-service-create-terminal.vue?vue&type=script&lang=js"
import style0 from "./on-service-create-terminal.vue?vue&type=style&index=0&id=c1a412a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports